import React, { Fragment } from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';
import PropTypes from 'prop-types';

const propTypes = {
  invoiceTo: PropTypes.string.isRequired,
  invoiceTo2: PropTypes.string.isRequired,
};

const InvoiceTo = ({ invoiceTo, invoiceTo2 }) => {
  return (
    <Fragment>
      <View style={styles.invoiceTo}>
        <Text style={styles.invoiceToText}>{invoiceTo}</Text>
        {invoiceTo2.length > 0 && (
          <Text style={styles.invoiceToText2}>{invoiceTo2}</Text>
        )}
      </View>
    </Fragment>
  );
};

InvoiceTo.propTypes = propTypes;

export default InvoiceTo;
